import type { Adb } from '@yume-chan/adb';

// ADB multiplexes all sockets over one USB pipe, so a process whose output is left unread stalls
// every other command on the same device. `spawnWaitText` drains the streams before resolving.
export async function adbShell(adb: Adb, ...args: string[]): Promise<string> {
  const shellProtocol = adb.subprocess.shellProtocol;

  if (!shellProtocol) {
    return adb.subprocess.noneProtocol.spawnWaitText(args).then((output) => output.trim());
  }

  return shellProtocol.spawnWaitText(args).then((result) => (result.stdout + result.stderr).trim());
}
